import { CalendarRemoveIcon } from './CalendarRemoveIcon';

/**
 * author: Google
 * id 2FAF3098-4BD1-4C70-94A8-F75E1EA54F49
 * name calendar-remove
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-remove.svg
 * tags
 * - Date / Time 
 */
export const EventBusyIcon = CalendarRemoveIcon;
export default EventBusyIcon